import GenericDiscoverView from './DiscoverView';

const DiscoverView = (props) => {
  return <GenericDiscoverView {...props} />;
};

export default DiscoverView;
